/* eslint-disable angular/no-service-method */

angular.
module("digiexam.exam").
service("ExamRepository", function ExamRepositoryService(
	$http,
	$q,
	Exam,
	DxQuestion,

	dxSession
) {
	"use strict";

	var self = this;
	self.exams = [];
	self.subjects = [];

	self.cache = function cache(exam) {
		var found = false;
		// Copy property by property to prevent full rerender of ng-repeats
		for (var j = 0; j < self.exams.length; j++) {
			var e = self.exams[j];
			if (exam.id === e.id && exam.id !== 0) {
				for (var key in exam) {
					// Checks to prevent copy of properties that is the same
					if (typeof exam[key] === "function") {
						continue;
					}

					if (exam[key] instanceof Array && exam[key].compare(e[key])) {
						continue;
					}

					if (e[key] === exam[key]) {
						continue;
					}

					var cachedVersionHasQuestions = e.questions !== null && e.questions.length !== 0;

					if (key === "questions" && cachedVersionHasQuestions) {
						continue;
					}

					if (key === "students") {
						continue;
					}

					// Might have to update the parent of questions

					e[key] = exam[key];
				}

				found = true;
				e.setDirty(false);
				break;
			}
		}

		if (!found && exam.id !== 0) {
			self.exams[self.exams.length] = exam;
		}

		// Cache the subject if it doesn't exist yet.
		var foundSubject = false;

		for (var k = 0; k < self.subjects.length; k++) {
			var s = self.subjects[k];
			if (s === exam.subject) {
				foundSubject = true;
				break;
			}
		}

		if (!foundSubject) {
			self.subjects[self.subjects.length] = exam.subject;
		}
	};

	self.load = function load(id) {
		// Always fire reload of the object from the server.
		var promise = $http.get("/exam/" + id).then(function success(response) {
			if (response.data == null) { // eslint-disable-line eqeqeq, no-eq-null
				return null;
			}
			var exam = new Exam(response.data.exam);
			self.cache(exam);
			return exam;
		});

		// But use the cached one if found, the cached one will be updated from the server when it arrives.
		for (var j = 0; j < self.exams.length; j++) {
			var e = self.exams[j];
			if (e.id === id) {
				var deferred = $q.defer();
				deferred.resolve(e);
				promise = deferred.promise;
			}
		}

		return promise;
	};

	self.erase = function erase(id) {
		return $http.post("/exam/erase/", {
			examId: id,
		}).then(function success(response) {
			if (response.data.faults == null) { // eslint-disable-line eqeqeq, no-eq-null
				for (var i = 0; i < self.exams.length; i++) {
					var e = self.exams[i];
					if (e.id === id) {
						self.exams.splice(i, 1);
						break;
					}
				}

				return response.data;
			}

			return $q.reject(response);
		});
	};

	self.save = function save(exam) {
		return $http.post("/exam/save/", exam).then(function success(response) {
			if (response.status !== 200) { // TODO: DIRTY, NEED A NEAT CONSISTENT WAY TO COMMUNICATE ERRORS TO THE VIEW
				return false;
			}

			var e = new Exam(response.data);
			self.cache(e);
			return e;
		});
	};

	self.saveQuestions = function saveQuestions(examId, questions) {
		return $http.post("/exam/questions/save/" + examId, questions).then(function success(response) {
			if (response.status !== 200) { // TODO: DIRTY, NEED A NEAT CONSISTENT WAY TO COMMUNICATE ERRORS TO THE VIEW
				return false;
			}

			// Update questions on the exam with the response from the server
			var questionResponse = response.data;
			for (var i = 0; i < questionResponse.length; i++) {
				questionResponse[i] = new DxQuestion(questionResponse[i].type, questionResponse[i]);
			}

			for (var k = 0; k < self.exams.length; k++) {
				var e = self.exams[k];
				if (e.id === examId) {
					e.questions = questionResponse;
				}
			}

			return questionResponse;
		});
	};

	function cacheExamsFromResponse(response) {
		// Figure out why response.data would be null in some cases
		try {
			if (response.data.exams != null) { // eslint-disable-line eqeqeq, no-eq-null
				var results = []; // TODO: Needed or caused by the coffeescript conversion?
				for (var j = 0; j < response.data.exams.length; j++) {
					var e = response.data.exams[j];
					var exam = new Exam(e);
					results.push(self.cache(exam));
				}

				return results;
			}
		} catch (_error) {
			Raven.captureException(_error, { // eslint-disable-line no-undef
				extra: {
					response: response,
				},
			});
		}

		return null;
	}

	self.refreshDashboard = function refreshDashboard() {
		$http.get("/exam/list/dashboard/").then(function success(response) {
			cacheExamsFromResponse(response);
			return true; // NOTE: What am I supposed to return here?
		});
	};

	self.refreshGroupExams = function refreshGroupExams(groupId, courseId) {
		$http.post("/group/getexams/", {
			groupId: groupId,
			courseId: courseId,
		}).then(function success(response) {
			cacheExamsFromResponse(response);
			return true; // NOTE: What am I supposed to return here?
		});
	};

	self.removeShare = function removeShare(e) {
		return $http.delete("/api/v1/examtemplates/" + e.id + "/shares?userId=" + dxSession.getUser().id).then(function success() {
			var index = self.exams.indexOf(e);

			if (index > -1) {
				self.exams.splice(index, 1);
			}

			return true;
		}, function failed() {
			return false;
		});
	};
});
